import React, { useEffect, useRef, useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";
import { pharmacistImg } from "../mock";

const botReplies = [
  "Sure! Could you share the medicine name or upload your prescription?",
  "That medicine is in stock and eligible for 15% off on your first order.",
  "We deliver across India within 24-48 hours. Anything else I can help with?",
  "Our pharmacists verify every prescription before dispatch. Your health is our priority!",
];

const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Hi! I'm your ArogyaMeds pharmacist. How can I help you today?",
    },
  ]);
  const replyIdx = useRef(0);
  const bottomRef = useRef(null);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-chat", handler);
    return () => window.removeEventListener("open-chat", handler);
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  const send = () => {
    const text = input.trim();
    if (!text) return;
    setMessages((m) => [...m, { from: "user", text }]);
    setInput("");
    setTimeout(() => {
      setMessages((m) => [
        ...m,
        { from: "bot", text: botReplies[replyIdx.current % botReplies.length] },
      ]);
      replyIdx.current += 1;
    }, 900);
  };

  return (
    <>
      {open && (
        <div className="fixed bottom-20 right-4 w-[320px] h-[400px] bg-white rounded-2xl shadow-2xl border border-gray-100 flex flex-col z-50 overflow-hidden animate-hero-fade">
          <div className="bg-[#0f9d4b] px-4 py-3 flex items-center gap-3">
            <div className="relative">
              <img src={pharmacistImg} alt="" className="w-9 h-9 rounded-full object-cover" />
              <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-300 border-2 border-[#0f9d4b] rounded-full" />
            </div>
            <div className="flex-1">
              <div className="text-white text-[13.5px] font-bold leading-tight">
                Arogya Pharmacist
              </div>
              <div className="text-white/80 text-[10.5px]">Online · replies instantly</div>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white">
              <X size={17} />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-3 space-y-2.5 bg-[#f6faf7]">
            {messages.map((m, i) => (
              <div key={i} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}>
                <div
                  className={`max-w-[80%] px-3 py-2 rounded-2xl text-[12.5px] leading-snug ${
                    m.from === "user"
                      ? "bg-[#12a150] text-white rounded-br-sm"
                      : "bg-white text-gray-700 border border-gray-100 rounded-bl-sm shadow-sm"
                  }`}
                >
                  {m.text}
                </div>
              </div>
            ))}
            <div ref={bottomRef} />
          </div>
          <div className="p-2.5 border-t border-gray-100 flex gap-2">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Type your message..."
              className="flex-1 border border-gray-200 rounded-full px-3.5 py-2 text-[12.5px] outline-none focus:border-[#12a150]"
            />
            <button
              onClick={send}
              className="w-9 h-9 rounded-full bg-[#12a150] hover:bg-[#0d8a40] text-white flex items-center justify-center transition-colors"
            >
              <Send size={15} />
            </button>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-4 right-4 p-3.5 rounded-full bg-[#12a150] hover:bg-[#0d8a40] text-white shadow-lg hover:shadow-xl z-50 transition-[background-color,box-shadow]"
      >
        {open ? <X size={22} /> : <MessageCircle size={22} />}
      </button>
    </>
  );
};

export default ChatWidget;
